require('./cardCancelDeferPurchaseSuccess.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');

// @common
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

// @components
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

// @helpers
const { formatText } = require('core/i18n').i18n;

//@utilities
const currencyHelper = require('utilities/currencyHelper');

class CardCancelDeferPurchaseSuccess extends React.Component {

    render() {
        const { cardId, immCard, immAccounts, immCardCancelDeferPurchase, immMovement } = this.props;
        const cancelDeferPurchaseData = immCardCancelDeferPurchase.get('cancelDeferPurchaseData');
        const currency = currencyHelper.formatCurrency(immMovement.getIn(['import', 'currency']));
        const amountToBePaidTitle = formatText('cardCancelDeferPurchase-cardCancelDeferPurchase_totalAmountSuccessTitle');
        const totalAmountToBePaidValue = currencyHelper.formatAmount((cancelDeferPurchaseData.getIn(['importeCapitalPend', 'importe']) + cancelDeferPurchaseData.getIn(['importeInteres', 'importe']))) + ' ' + currency;
        const accountSelectedTitle = formatText('cardCancelDeferPurchase-cardCancelDeferPurchase_accountAssociated');
        const associatedAccountNumber = immCard.get('associatedAccount');
        const originAccount = immAccounts.get('byId').find(function (account) {
            return account.get('contractNumber').substr(-4) === associatedAccountNumber.substr(-4);
        });
        const originAccountAlias = originAccount && (originAccount.get('alias'));
        const associatedAccountNumberText = `${originAccountAlias} ...${associatedAccountNumber.substr(-4)}`;
        const successTitle = (formatText('cardCancelDeferPurchase-cardCancelDeferPurchase_successTitle'))
        const cardAlias = immCard.getIn(['alias', 'current']);
        const goBackButtonLabel = formatText('cardCancelDeferPurchase-cardCancelDeferPurchase_backToCardsLink', [
            cardAlias
        ]).toUpperCase();
        const mainButton = {
            label: goBackButtonLabel,
            url: `/myprofile/cards/${cardId}/movements`
        };

        return (
            <div className="grid-view__body">
                <div className="container-fluid">
                    <div className="row grid-view--content-position-negative">
                        <div className="confirm-success-step col-xs-offset-2 col-xs-8">
                            <WizardSuccess
                                customClassName="card-cancel-defer-purchase-success"
                                successMessage={successTitle}
                                mainButton={mainButton}
                            >
                                <div className="row card-cancel-defer-purchase-success__details-container">
                                    <OKInformativeList columns={2}>
                                        <OKInformativeListItem
                                            title={amountToBePaidTitle} bodyText={totalAmountToBePaidValue}
                                        />
                                        <OKInformativeListItem
                                            title={accountSelectedTitle} bodyText={associatedAccountNumberText}
                                        />
                                    </OKInformativeList>
                                </div>
                            </WizardSuccess>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CardCancelDeferPurchaseSuccess.propTypes = {
    cardId: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCard: PropTypes.object.isRequired,
    immCardCancelDeferPurchase: PropTypes.object.isRequired,
    immMovement: PropTypes.object.isRequired
};

module.exports = CardCancelDeferPurchaseSuccess;
